export default __webpack_public_path__ + "static/media/IconInfo.85f9c205.png";